<template>
  <v-card>
    <v-snackbar
      v-model="snackbar.open"
      tile
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}

      <template #action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.open = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
    <v-menu
      v-model="selectedChip.open"
      :activator="selectedChip.element"
      offset-y
      top
    >
      <v-card color="black">
        <v-card-subtitle class="pa-1 white--text">
          <ul>
            <li>
              <strong>Tono: </strong>{{ selectedChip.tono.tono }}
            </li>
            <li>
              <strong>Frecuencia: </strong>{{ selectedChip.tono.frequency }}
            </li>
            <li>
              <strong>Tipo: </strong>{{ selectedChip.tono.type }}
            </li>
            <li>
              <strong>Volumen: </strong>{{ selectedChip.tono.volume }}
            </li>
            <li>
              <strong>Duración: </strong>{{ selectedChip.tono.duration }}
            </li>
          </ul>
        </v-card-subtitle>
      </v-card>
    </v-menu>
    <v-card-text class="pa-0">
      <v-simple-table>
        <thead>
          <tr>
            <th colspan="2">
              Compañía
            </th>
            <v-divider
              style="height: 30px"
              inset
              vertical
            />
            <th colspan="3">
              Tonos
            </th>
          </tr>
          <tr>
            <th>
              Número
            </th>
            <v-divider
              style="height: 30px"
              inset
              vertical
            />
            <th>
              Seleccionados
            </th>
            <th>
              Línea de tiempo
            </th>
            <th>
              Prueba
            </th>
            <th>
              Edición
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="companniaTono in companniasTonoLocal"
            :key="`compannia-tono-${companniaTono.companniaId}`"
          >
            <td>
              {{ companniaTono.numero }}
            </td>
            <v-divider
              style="height: 30px"
              inset
              vertical
            />
            <td>
              <v-select
                v-model="companniaTono.tonosIds"
                :items="tonos"
                multiple
                item-text="tono"
                item-value="tonoId"
                dense
              />
            </td>
            <td>
              <v-card outlined>
                <v-card-text class="pa-0">
                  <draggable
                    :list="companniaTono.tonosIds"
                    :group="{ name: `draggable-compannia-tono-${companniaTono.companniaId}`}"
                    class="draggable-min"
                    @start="dragging = true"
                    @end="dragging = false"
                  >
                    <v-chip
                      v-for="tonoId in companniaTono.tonosIds"
                      :key="`tono-id${tonoId}-compannia-tono-${companniaTono.companniaId}`"
                      draggable
                      color="primary"
                      class="ma-1"
                      label
                      @click="showChipDescription($event, tonoId)"
                    >
                      {{ tonoNombre(tonoId) }}
                    </v-chip>
                  </draggable>
                </v-card-text>
              </v-card>
            </td>
            <td>
              <v-btn
                fab
                color="primary"
                small
                depressed
                :disabled="companniaTono.tonosIds.length === 0"
                @click="playTonos(companniaTono.tonosIds)"
              >
                <v-icon>
                  {{ icons.mdiPlay }}
                </v-icon>
              </v-btn>
            </td>
            <td>
              <v-btn
                fab
                color="primary"
                small
                depressed
                :disabled="companniaIdEqualGuardado(companniaTono)"
                :loading="companniaTono.loading"
                @click="saveCompanniaTonos(companniaTono)"
              >
                <v-icon>
                  {{ icons.mdiContentSaveAll }}
                </v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import draggable from 'vuedraggable'
import { mdiContentSaveAll, mdiPlay } from '@mdi/js'
import { playSounds } from '@/utils/sounds'

export default {
  name: 'TonosCompanniaTab',
  components: {
    draggable
  },
  data () {
    return {
      playSounds,
      icons: {
        mdiPlay,
        mdiContentSaveAll
      },
      snackbar: {
        open: false,
        color: 'success',
        timeout: 3000,
        text: ''
      },
      dragging: false,
      companniasTonoLocal: [],
      selectedChip: {
        open: false,
        element: null,
        tono: {
          tonoId: null,
          tono: '',
          frequency: 600,
          type: 'sine',
          volume: 10,
          duration: 500
        }
      }
    }
  },
  computed: {
    ...mapState('emergencias', ['tonos', 'companniasTonos']),
    ...mapState('main', ['compannias'])
  },
  mounted () {
    this.companniasTonoLocal = this.compannias.map((compannia) => {
      const companniaTonos = this.companniasTonos.find((companniaTonos) => {
        return companniaTonos.companniaId === compannia.companniaId
      })
      const tonosIds = companniaTonos ? companniaTonos.tonosIds : []
      return {
        companniaId: compannia.companniaId,
        numero: compannia.numero,
        tonosIds: [...tonosIds],
        loading: false
      }
    })
  },
  methods: {
    companniaIdEqualGuardado ({ companniaId, tonosIds }) {
      const companniaTonosGuardados = this.companniasTonos.find((companniaTono) => {
        return companniaTono.companniaId === companniaId
      })
      if (!companniaTonosGuardados) {
        return false
      }
      return JSON.stringify(companniaTonosGuardados.tonosIds) === JSON.stringify(tonosIds)
    },
    saveCompanniaTonos (companniaTono) {
      const { companniaId, tonosIds } = companniaTono
      companniaTono.loading = true
      const data = {
        companniaId,
        tonosIds
      }
      this.$store.dispatch('emergencias/updateCompanniaTonos', data)
        .then(({ data }) => {
          this.snackbar.text = data.message
          this.snackbar.color = 'success'
        })
        .catch((error) => {
          let message = ''
          if (error.response) {
            message = error.response.data.message
          } else if (error.request) {
            message = 'Problemas de conexión o servidor no responde'
          } else {
            message = 'Error, contactar administrador'
          }
          this.snackbar.text = message
          this.snackbar.color = 'error'
        })
        .finally(() => {
          this.snackbar.open = true
          companniaTono.loading = false
        })
    },
    tonoNombre (tonoId) {
      return this.tonos.find((tono) => tono.tonoId === tonoId)?.tono
    },
    showChipDescription (nativeEvent, tonoId) {
      const open = () => {
        this.selectedChip.tono = this.tonos.find((tono) => tono.tonoId === tonoId)
        this.selectedChip.element = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => {
          this.selectedChip.open = true
        }))
      }

      if (this.selectedChip.open) {
        this.selectedChip.open = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    },
    playTonos (tonosIds) {
      const tonos = tonosIds.map((tonoId) => {
        return this.tonos.find((tono) => tono.tonoId === tonoId)
      })
      this.playSounds(tonos)
    }
  }
}
</script>

<style scoped>
.draggable-min {
  width: 100%;
  min-height: 30px;
  height: 100%;
  min-width: 200px;
}

</style>
